/**
 * 路由配置
 * 基于路由meta数据生成菜单、面包屑和权限控制
 */

import LayoutPage from '../views/LayoutPage.vue'
import LoginPage from '../views/LoginPage.vue'
import ProductMgmt from '../views/ProductMgmt.vue'
import ProductTagMgmt from '../views/ProductTagMgmt.vue'
import ApiKeyMgmt from '../views/ApiKeyMgmt.vue'
import AccountMgmt from '../views/AccountMgmt.vue'

/**
 * 路由配置
 * 注意：所有需要在侧边栏展示的路由都必须设置 meta.title 和 meta.icon
 * 子路由会自动成为父路由的下拉菜单
 */
export const constantRoutes = [
  {
    path: '/login',
    component: LoginPage,
    hidden: true // 不在侧边栏显示
  },
  {
    path: '/',
    component: LayoutPage,
    redirect: '/products',
    meta: { requiresAuth: true },
    children: [
      {
        path: '/products',
        name: 'products',
        component: ProductMgmt,
        meta: {
          title: '产品型号',
          icon: 'Cpu',
          requiresAuth: true
        }
      },
      {
        path: '/product-tags',
        name: 'product-tags',
        component: ProductTagMgmt,
        meta: {
          title: '产品标签',
          icon: 'CollectionTag',
          requiresAuth: true
        }
      },
      {
        path: '/apikeys',
        name: 'apikeys',
        component: ApiKeyMgmt,
        meta: {
          title: '访问密钥',
          icon: 'Key',
          requiresAuth: true
        }
      },
      {
        path: '/accounts',
        name: 'accounts',
        component: AccountMgmt,
        meta: {
          title: '账号管理',
          icon: 'UserFilled',
          requiresAuth: true
        }
      }
    ]
  }
]

/**
 * 从路由配置中生成菜单项
 * @param {Array} routes 路由配置
 * @returns {Array} 菜单项数组
 */
export function generateMenuFromRoutes(routes) {
  const menuItems = []
  
  routes.forEach(route => {
    // 跳过隐藏的路由
    if (route.hidden) {
      return
    }
    
    // 处理有子路由的情况
    if (route.children && route.children.length > 0) {
      // 如果父路由有component（如LayoutPage），需要创建菜单项
      const menuItem = {
        path: route.path,
        name: route.name,
        meta: route.meta || {},
        children: generateMenuFromRoutes(route.children)
      }
      
      // 如果父路由有重定向，记录到菜单项
      if (route.redirect) {
        menuItem.redirect = route.redirect
      }
      
      menuItems.push(menuItem)
    } else if (route.meta && route.meta.title) {
      // 叶子节点（没有子路由）
      const menuItem = {
        path: route.path,
        name: route.name,
        meta: route.meta
      }
      menuItems.push(menuItem)
    }
  })
  
  return menuItems
}

/**
 * 获取当前路由的面包屑路径
 * @param {Array} routes 路由配置
 * @param {String} currentPath 当前路径
 * @returns {Array} 面包屑数组
 */
export function generateBreadcrumbFromRoutes(routes, currentPath) {
  function findRoute(path, routeList, parentChain = []) {
    for (const route of routeList) {
      const chain = [...parentChain, route]
      
      if (route.path === path) {
        return chain
      }
      
      if (route.children) {
        const found = findRoute(path, route.children, chain)
        if (found) {
          return found
        }
      }
    }
    return null
  }
  
  const chain = findRoute(currentPath, routes)
  if (chain) {
    return chain.filter(route => route.meta && route.meta.title)
  }
  
  return []
}

/**
 * 获取所有需要权限的路由
 */
